import { render, staticRenderFns } from "./partner-order.vue?vue&type=template&id=2ac2c125&scoped=true&"
import script from "./partner-order.vue?vue&type=script&lang=js&"
export * from "./partner-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2c125",
  null
  
)

export default component.exports